import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Comments from './components/Comments';
import MediaSection from './components/MediaSection';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import CarouselSection from './components/CarouselSection';
import About from './components/About';
import Ranking from './components/Ranking';
import AppEntry from './components/AppEntry';
import Updates from './components/Updates';
import TopicIndex from './components/TopicIndex';
import Cards from './components/Cards';
import Topics from './components/Topics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Comments />
        <MediaSection />
        <Contact />
        <FAQ />
        <CarouselSection />
        <About />
        <Ranking />
        <AppEntry />
        <Updates />
        <TopicIndex />
        <Cards />
        <Topics />
      </main>
      <Footer />
    </>
  );
}